import { ChangeEvent } from 'react';

import FormInput from '../../FormInput';
import FormSection from '../../FormSection';

const getPropertyValue = (configuration: any, name: string) =>
  configuration.clientConnectorProperties?.find((_: any) => _.Name === name)?.Value || '';

const MedicalDirectorHelixBusiness2CloudConnectorConfiguration = ({ configuration }: any) => (
  <FormSection>
    <div className="form-section-header">
      <h5>MedicalDirector Helix Credentials</h5>
      <span>API keys required for MedicalDirector Helix access</span>
    </div>
    <FormInput
      required
      id="medicaldirectorhelix.clientId"
      name="medicaldirectorhelix.clientId"
      label="Client ID"
      placeholder="Enter Helix client ID"
      value={getPropertyValue(configuration, 'medicaldirectorhelix.clientId')}
      onChange={(event: ChangeEvent<HTMLInputElement>) =>
        configuration.onClientConnectorPropertyChange(event, 'medicaldirectorhelix.clientId')
      }
    />
    <FormInput
      required
      type="password"
      id="medicaldirectorhelix.clientSecret"
      name="medicaldirectorhelix.clientSecret"
      label="Client Secret"
      placeholder="Enter Helix client secret"
      value={getPropertyValue(configuration, 'medicaldirectorhelix.clientSecret')}
      onChange={(event: ChangeEvent<HTMLInputElement>) =>
        configuration.onClientConnectorPropertyChange(event, 'medicaldirectorhelix.clientSecret')
      }
    />
  </FormSection>
);

export default MedicalDirectorHelixBusiness2CloudConnectorConfiguration;
